import * as React from "react"
import { Box } from "@mui/material"
import { translateCountryName } from "@ui-seeker/utils"

import { HierarchicalTextBlock, LabelCountry } from "@components"
import { CategoryText } from "../@components"


export default function retailerInfoColumn() {
	return [{
		name: 'country', label: 'Country',
		options: {
			display: 'excluded',
			customBodyRowRender: value => translateCountryName(value)
		}
	}, {
		name: 'retailer', label: 'retailer',
		options: { display: 'excluded' }
	}, {
		name: 'gifts', label: 'Has Gifts?',
		options: {
			display: "excluded",
			filterType: "checkbox",
			customBodyRowRender: value => value ? 'Yes' : 'No'
		}
	}, {
		name: 'hasRichContent', label: 'Has Rich Content?',
		options: {
			display: "excluded",
			filterType: "checkbox",
			customBodyRowRender: value => value ? 'Yes' : 'No'
		}
	}, {
		name: 'stock', label: 'In Stock',
		options: {
			display: 'excluded',
			filterType: 'checkbox',
			customBodyRowRender: value => value ? 'Yes' : 'No'
		}
	}, {
		name: "retailer", label: "Retailer Info",
		options: {
			filter: false,
			customBodyRowRenderLite: (value, { country, stock, gifts, hasRichContent }) => {
				const stockIcon = stock ? 'store' : 'store-slash'
				const stockLabel = stock ? 'In Stock' : 'Out of stock'
				const stockColor = stock ? 'success' : 'error'

				const giftLabel = gifts ? 'yes': 'no'
				const giftColor = gifts ? 'success': 'error'

				const richContentLabel = hasRichContent ? 'yes': 'no'
				const richContentColor = hasRichContent ? 'success': 'error'

				return <Box sx={{ display: 'flex', flexDirection: 'column' }}>
					<LabelCountry country={country} label={value} />
					<HierarchicalTextBlock subtitle="Gifts? " subtitleValue={<CategoryText label={giftLabel} color={giftColor} />} />
					<HierarchicalTextBlock subtitle="Rich Content? " subtitleValue={<CategoryText label={richContentLabel} color={richContentColor} />} />
					{/*<IconDataBlock icon={stockIcon} value={stockLabel} iconProps={{ sx: { color: `${stockColor}.dark` } }} />*/}
				</Box>
			}
		}
	}]
}